<div class="dialogContent">
  <mat-toolbar color="primary">
    <div fxFlex>انتخاب مرکز</div>
    <button mat-icon-button (click)="dialogRef.close()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar>
  <mat-card-content>
    <div class="inputWrapper ma-10">
      <input placeholder="جستجو .." #filter (keyup)="filterNodes(filter.value, tree)" />
    </div>
    <tree-root #tree [nodes]="nodes" [options]="customTemplateStringOptions" [focused]="true" (onEvent)="onEvent($event)">
      <ng-template #treeNodeTemplate let-node>
        <span title="{{ node.data.name }}">{{ node.data.name }}</span>
        <span class="pull-right">{{ childrenCount(node) }}</span>
        <div fxFlex></div>
        <mat-checkbox (change)="changeBranchList(node.data, $event.checked)" value="0"></mat-checkbox>
      </ng-template>
    </tree-root>
  </mat-card-content>
</div>
<div class="center pa-10">
  <button mat-raised-button class="confirmBranch" color="primary" (click)="dialogRef.close(Selectedbranche)">اعمال فیلتر مرکز</button>
</div>
